import React from 'react';
import ChevronDownIcon from '../../icons/chevron-down.svg';
import { translate } from '../Services/translation';

const PriceModelSelector = (props) => {
    const { carPriceLists, setCarPriceList, includeHeader} = props;
    const selectedPriceListSystemId = carPriceLists.find(x => x.isSelected === true).priceListSystemId;
    return (
        <div className="price-model-selector">
            <select className="form__input form__input--priceselector" onChange={(event) => {
                setCarPriceList(event.target.value);
            }}
                value={includeHeader === true ? -1 : selectedPriceListSystemId}>
                {includeHeader &&
                    <option disabled value={-1}>{translate('pricemodelselector.changemethod')}</option>
                }
                {carPriceLists.map((pricelist) => 
                    <option value={pricelist.priceListSystemId} key={pricelist.priceListSystemId}>{pricelist.displayName}</option>
                    )}
            </select>
            <ChevronDownIcon className="icon"/>
        </div>
    )
}

export default PriceModelSelector;